/**
 * Tệp ngôn ngữ. Mọi chuỗi hiển thị cho người dùng nằm ở đây, không viết trực tiếp
 * trong thành phần (AGENTS.md mục 6).
 *
 * Nhãn trạng thái ở `trangThaiThietBi` phải khớp TUYỆT ĐỐI Bảng 3.4 tài liệu đặc
 * tả giao diện; giao diện không được tự tạo trạng thái mới.
 */
export const vi = {
  ungDung: {
    ten: 'Hệ thống thông tin nguồn thông tin cơ sở',
    tenNgan: 'Thông tin nguồn thông tin cơ sở cấp tỉnh',
  },
  thanhDauTrang: {
    timKiem: 'Tìm kiếm',
    thongBao: 'Thông báo',
    hoSo: 'Hồ sơ người dùng',
    dangXuat: 'Đăng xuất',
    chuaDangNhap: 'Chưa đăng nhập',
    chuaCoCongViecNen: 'Chưa có công việc âm thanh nào đang xử lý',
    congViecDangXuLyMoTa: 'đang xử lý…',
    congViecXongMoTa: 'đã xong',
    congViecLoiMoTa: 'thất bại',
  },
  dieuHuong: {
    tongQuan: 'Tổng quan',
    thietBi: 'Cụm loa truyền thanh',
    banTin: 'Biên tập nội dung',
    lichPhat: 'Lịch phát thanh',
    phatSong: 'Phát sóng',
    bangTinDienTu: 'Bảng điện tử công cộng',
    baoCao: 'Báo cáo thông tin cơ sở',
    thongKe: 'Thống kê',
    tichHop: 'Tích hợp trung ương',
    danhMuc: 'Danh mục',
    quanTri: 'Quản trị hệ thống',
    quanLyLog: 'Quản lý log',
    thongTinCaNhan: 'Thông tin cá nhân',
    huongDan: 'Hướng dẫn sử dụng',
    thongBao: 'Thông báo',
  },
  /** Mục con của menu dọc (bản mẫu CMS "Thông tin nguồn"). */
  menuCon: {
    danhSachCumLoa: 'Cụm loa',
    lichPhatThanh: 'Lịch phát thanh',
    thongKeDaiPhatThanh: 'Danh sách đài truyền thanh',
    nhatKyBanTinDaPhat: 'Nhật ký bản tin đã phát',
    nhatKyLichPhatThietBi: 'Nhật ký lịch phát thiết bị',
    nhatKyHuyLichPhat: 'Nhật ký hủy lịch phát',
    banDoThietBi: 'Bản đồ thiết bị',
    phatKhanCap: 'Phát khẩn cấp',
    phatTrucTiep: 'Phát trực tiếp',
    tiepSong: 'Tiếp sóng',
    bangDienTu: 'Bảng điện tử',
    lichPhatBangTin: 'Lịch phát bảng tin',
    thongKeTheoDiaBan: 'Thống kê thiết bị theo địa bàn',
    nhanDuyetGuiBaoCao: 'Nhận duyệt gửi báo cáo',
    baoCaoDinhKy: 'Quản lý báo cáo thông tin cơ sở',
    khoNoiDungCaNhan: 'Kho nội dung cá nhân',
    trinhPheDuyet: 'Trình phê duyệt',
    xuatBan: 'Xuất bản',
    khoThongTinNguon: 'Kho thông tin nguồn',
    khoAmThanh: 'Kho âm thanh',
    quanTriCumLoa: 'Danh sách quản trị cụm loa',
    quanTriBangDienTu: 'Danh sách quản trị bảng điện tử',
    cauHinhBaoCaoDong: 'Cấu hình báo cáo động',
    linhVucCapHai: 'Quản lý lĩnh vực cấp 2',
    nguoiDung: 'Người dùng',
    nhomQuyen: 'Nhóm quyền',
    donViHanhChinh: 'Đơn vị hành chính',
    daTinh: 'Quản trị đa tỉnh',
    lienHe: 'Liên hệ',
    nhaCungCap: 'Nhà cung cấp thiết bị',
    logDieuKhien: 'Điều khiển thiết bị',
    logDangNhap: 'Đăng nhập hệ thống',
    logTrungUong: 'Gửi dữ liệu lên trung ương',
    logCauHinh: 'Cấu hình hệ thống',
  },
  /** Đánh dấu phần giao diện mà backend chưa có API. */
  chuaCoApi: {
    nhan: 'Chưa có API',
    goiY: 'Backend chưa có API cho chức năng này; giao diện hiển thị theo mẫu, chưa có dữ liệu.',
    tieuDe: 'Chức năng chưa có API',
    moTa: 'Giao diện dựng theo mẫu nhưng chưa nối dữ liệu vì backend chưa cung cấp API.',
    canBoSung: 'Cần bổ sung',
    bangTrong: 'Trống',
    tongKhongXacDinh: 'Tổng 0 bản ghi',
  },
  /** Trang Hướng dẫn sử dụng. */
  huongDan: {
    tieuDe: 'Hướng dẫn sử dụng Hệ thống thông tin nguồn',
    moDau: 'Tóm tắt các thao tác chính. Mỗi mục ghi đường đi trên menu dọc bên trái.',
    phan: [
      {
        tieuDe: '1. Tạo và trình duyệt bản tin',
        buoc: [
          'Vào Biên tập nội dung → Kho nội dung cá nhân, bấm "Biên tập nội dung".',
          'Chọn cách tạo nội dung: tải tệp âm thanh, chuyển văn bản thành giọng đọc, cắt ghép tệp.',
          'Điền tên bản tin, lĩnh vực, mức độ ưu tiên rồi lưu; sau đó bấm "Trình duyệt".',
          'Người duyệt vào Biên tập nội dung → Trình phê duyệt, nghe lại bản tin rồi duyệt hoặc từ chối. Bản tin đã duyệt có ở mục Xuất bản.',
        ],
      },
      {
        tieuDe: '2. Lập lịch phát thanh',
        buoc: [
          'Vào Cụm loa truyền thanh → Lịch phát thanh, bấm "Thêm mới lịch".',
          'Chọn địa bàn, khoảng ngày, khung giờ, bản tin và thiết bị; hệ thống báo trùng lịch nếu có.',
          'Lịch còn hiệu lực có thể hủy; lịch đã hủy xem ở Nhật ký hủy lịch phát.',
        ],
      },
      {
        tieuDe: '3. Phát ngay, phát khẩn cấp và điều khiển thiết bị',
        buoc: [
          'Trong Cụm loa truyền thanh → Cụm loa, chọn thiết bị trong bảng rồi dùng "Điều khiển" hoặc "Phát ngay".',
          'Phát khẩn cấp ở Cụm loa truyền thanh → Phát khẩn cấp: hệ thống hiện phạm vi ảnh hưởng trước khi xác nhận.',
          'Trạng thái thiết bị tự làm mới sau mỗi 60 giây; tạm dừng khi đang chọn dòng hoặc tab bị ẩn.',
        ],
      },
      {
        tieuDe: '4. Bảng điện tử công cộng',
        buoc: [
          'Bảng điện tử công cộng → Bảng điện tử: danh sách bảng tin, thuộc tính màn hình, ảnh chụp.',
          'Bản tin điện tử: soạn nội dung, xem trước đúng tỷ lệ màn hình của bảng tin đích.',
          'Lịch phát bảng tin: tạo lịch phát vòng lặp cho các bảng tin.',
        ],
      },
      {
        tieuDe: '5. Báo cáo thông tin cơ sở',
        buoc: [
          'Báo cáo thông tin cơ sở → Quản lý báo cáo thông tin cơ sở: tạo kỳ báo cáo, xem số liệu tổng hợp, điều chỉnh có ghi lý do.',
          'Chốt kỳ để khóa số liệu; mở lại kỳ đã chốt cần ghi lý do và được ghi nhật ký.',
        ],
      },
    ],
  },
  /** Trang của bản mẫu CMS mà backend chưa có API (man-hinh/TrangChuaCoApi.tsx). */
  trangChuaCoApi: {
    tatCa: 'Tất cả',
    loc: {
      diaBan: 'Địa bàn',
      khoangNgay: 'Khoảng ngày',
      loaiBanTin: 'Loại bản tin',
      mucDoUuTien: 'Mức độ ưu tiên',
      linhVuc: 'Lĩnh vực',
    },
    nut: {
      xuatExcel: 'Xuất Excel',
      themMoiBaoCao: 'Thêm mới báo cáo',
    },
    cot: {
      nhatKyGuiLich: [
        'STT',
        'Tên lịch phát',
        'Địa bàn',
        'Mã địa bàn',
        'Số lượng bản tin',
        'Thời điểm gửi lịch',
      ],
      nhatKyHuyLich: ['STT', 'Tên lịch phát', 'Địa bàn hủy', 'Thời điểm hủy', 'Danh sách thiết bị'],
      nhatKyBanTin: [
        'STT',
        'Tên bản tin',
        'Thời gian phát',
        'Thiết bị phát',
        'Địa bàn phát',
        'Trạng thái',
        'Thời lượng',
        'Mức độ ưu tiên',
        'Loại bản tin',
        'Lĩnh vực',
      ],
      baoCaoDong: [
        'Mã báo cáo',
        'Tên báo cáo',
        'Cấp',
        'Trạng thái',
        'Lưu trữ',
        'Quy trình áp dụng',
        'Mẫu excel',
      ],
    },
  },
  /** Khung trang: topbar, menu dọc, chân trang. */
  khung: {
    thuGonMenu: 'Thu gọn menu',
    moRongMenu: 'Mở rộng menu',
    cheDoSang: 'Sáng',
    cheDoToi: 'Tối',
    doiCheDo: 'Đổi chế độ Sáng/Tối',
    logoTinh: 'Logo đơn vị',
    thongTinCaNhan: 'Thông tin cá nhân',
    phienDangNhap: 'Phiên đăng nhập',
    menuNguoiDung: 'Menu người dùng',
    phatTrienBoi: 'Phát triển bởi VTC Digital',
    /** Tiêu đề topbar của trang con không có mục menu riêng (khớp đường dẫn dài nhất). */
    tieuDeTrangCon: {
      '/ban-tin/moi': 'Biên tập nội dung',
      '/ban-tin/chon-loai': 'Biên tập nội dung',
      '/ban-tin/tao-tu-van-ban': 'Chuyển văn bản thành giọng đọc',
      '/thiet-bi/moi': 'Khai báo thiết bị',
      '/thiet-bi/nhap-khau': 'Nhập khẩu hàng loạt',
      '/lich-phat/moi': 'Thêm mới lịch',
      '/phat-song/ngay': 'Phát ngay',
      '/bang-tin-dien-tu/lich-phat/moi': 'Thêm mới lịch bảng tin',
      '/quan-tri/phien': 'Phiên đăng nhập',
    },
  },
  nguCanh: {
    tieuDe: 'Ngữ cảnh làm việc',
    tinh: 'Tỉnh',
    diaBan: 'Địa bàn',
    khoangThoiGian: 'Khoảng thời gian',
    chuaChon: 'Chưa chọn',
    toanTinh: 'Toàn tỉnh',
    doiPhamVi: 'Đổi phạm vi địa bàn',
    homNay: 'Hôm nay',
  },
  noiDung: {
    khungDangDung: 'Khung trang đã dựng. Màn hình nghiệp vụ sẽ do các đợt sau bổ sung.',
    khongTimThayTrang: 'Không tìm thấy trang',
  },

  /* ------------------------------ Đăng nhập ------------------------------ */
  dangNhap: {
    tieuDe: 'Đăng nhập hệ thống',
    tenDangNhap: 'Tên đăng nhập',
    matKhau: 'Mật khẩu',
    nut: 'Đăng nhập',
    dangXuLy: 'Đang đăng nhập...',
    loiChung: 'Không đăng nhập được. Kiểm tra lại tên đăng nhập và mật khẩu.',
    dangKiemTraPhien: 'Đang kiểm tra phiên làm việc...',
    nhapTenDangNhap: 'Nhập tên đăng nhập',
    nhapMatKhau: 'Nhập mật khẩu',
    hienMatKhau: 'Hiện mật khẩu',
    anMatKhau: 'Ẩn mật khẩu',
  },
  khongCoQuyen: {
    tieuDe: 'Bạn không có quyền truy cập màn hình này',
    moTa:
      'Màn hình này đòi hỏi quyền mà tài khoản của bạn chưa được cấp. ' +
      'Nếu công việc cần tới, hãy đề nghị quản trị hệ thống cấp thêm quyền.',
    quyenCan: 'Quyền cần có',
    veTongQuan: 'Về trang tổng quan',
  },

  /* --------------------- Năm trạng thái màn hình (Bảng 3.3) ------------------- */
  trangThaiManHinh: {
    dangTai: 'Đang tải dữ liệu...',
    dangTaiLau: 'Hệ thống vẫn đang truy vấn. Dữ liệu nhiều nên có thể mất thêm vài giây.',
    rongTieuDe: 'Chưa có dữ liệu',
    rongMoTa: 'Địa bàn này chưa khai báo cụm thu phát thanh nào.',
    rongHanhDong: 'Khai báo thiết bị mới',
    rongLocTieuDe: 'Không có kết quả phù hợp với bộ lọc hiện tại',
    rongLocMoTa: 'Thu hẹp hoặc bỏ một vài điều kiện lọc rồi thử lại.',
    rongLocHanhDong: 'Xóa lọc',
    loiTieuDe: 'Không tải được dữ liệu',
    loiMaLoi: 'Mã lỗi để đối chiếu nhật ký',
    loiMaYeuCau: 'Mã lời gọi',
    loiThuLai: 'Thử lại',
  },

  /* ------------------------ Bảng dữ liệu (Bảng 3.1) ----------------------- */
  bang: {
    timKiem: 'Tìm theo tên hoặc mã thiết bị',
    xoaLoc: 'Xóa lọc',
    daChon: 'Đã chọn',
    dong: 'dòng',
    chonTatCaTrang: 'Chọn tất cả dòng của trang này',
    chonMotDong: 'Chọn dòng',
    chonTatCaKetQua: 'Chọn toàn bộ {so} kết quả',
    chonTatCaKetQuaGhiChu:
      'Hành động sau đó áp dụng theo điều kiện lọc hiện tại, không theo danh sách mã cụ thể.',
    boChon: 'Bỏ chọn',
    hienThi: 'Hiển thị',
    trong: 'trong',
    trang: 'Trang',
    truoc: 'Trang trước',
    sau: 'Trang sau',
    soDongMoiTrang: 'Số dòng mỗi trang',
    tongBanGhi: 'Tổng {so} bản ghi',
    moiTrang: '/ trang',
    sapXepTang: 'sắp xếp tăng dần',
    sapXepGiam: 'sắp xếp giảm dần',
    tuLamMoi: 'Tự làm mới 60 giây',
    tamDungLamMoi: 'Tạm dừng tự làm mới: đang chọn dòng',
    tamDungLamMoiTabAn: 'Tạm dừng tự làm mới: tab đang ẩn',
    lamMoiNgay: 'Làm mới ngay',
    capNhatLuc: 'Cập nhật lúc',
  },

  /* ------------------ Nhãn trạng thái thiết bị (Bảng 3.4) ----------------- */
  trangThaiThietBi: {
    dang_phat: 'Đang phát',
    cho_phat: 'Chờ phát',
    mat_ket_noi: 'Mất kết nối',
    tam_dung: 'Tạm dừng',
    chua_kich_hoat: 'Chưa kích hoạt',
  },
  tuoiDuLieu: {
    giay: 'giây',
    phut: 'phút',
    gio: 'giờ',
    ngay: 'ngày',
    chuaCo: 'chưa có dữ liệu',
    nhan: 'tuổi dữ liệu',
  },

  /* ----------------------- Bộ chọn phạm vi địa bàn 3.6 ---------------------- */
  phamVi: {
    tieuDe: 'Chọn phạm vi địa bàn',
    tim: 'Tìm địa bàn',
    daChon: 'Đã chọn',
    xa: 'xã',
    thon: 'thôn',
    cumLoa: 'cụm loa',
    huy: 'Hủy',
    xacNhan: 'Xác nhận',
    chonMotPhan: 'chọn một phần',
    ghiChuNutCha:
      'Chọn một địa bàn cấp trên nghĩa là chọn toàn bộ địa bàn con của nó tại thời điểm thực hiện lệnh.',
    ghiChuPhamViNguoiDung: 'Chỉ hiển thị nhánh địa bàn bạn được phân công.',
    dangTaiCay: 'Đang tải cây địa bàn...',
    loiCay: 'Không tải được cây địa bàn',
  },

  /* ------------------------------ MH-01 ---------------------------------- */
  tongQuan: {
    tieuDe: 'Tổng quan điều hành',
    oTong: 'Thiết bị',
    oHoatDong: 'Hoạt động',
    oMatKetNoi: 'Mất kết nối',
    ghiChuO: 'Bấm vào ô để mở danh sách thiết bị đã lọc theo trạng thái tương ứng',
    tichHopTieuDe: 'Tình trạng tích hợp',
    hangDoiChieuRa: 'Hàng đợi chiều ra',
    goiTinThatBai: 'Gói tin thất bại',
    guiCuoi: 'Gửi thành công cuối',
    chuaGui: 'chưa có lần gửi thành công nào',
    boTuongThich: 'bộ tương thích',
    guiTrungUong: 'Gửi dữ liệu lên hệ thống trung ương',
    congTacGui: 'Công tắc gửi',
    congTacBat: 'Đang bật',
    congTacTat: 'Đang tắt',
    nhaCungCapTieuDe: 'Nhà cung cấp thiết bị',
    nccQuaBtt: '{btt} bộ tương thích, {so} thiết bị qua bộ tương thích',
    nccTrucTiep: '{so} cụm loa kết nối trực tiếp',
    nccBangTinTrucTiep: '{so} bảng điện tử kết nối trực tiếp',
    nccChuaCoThietBi: 'chưa có thiết bị, chưa có bộ tương thích',
    topTieuDe: 'Top địa bàn có thiết bị mất kết nối',
    topGhiChu: 'Xếp theo tỷ lệ mất kết nối, không theo số tuyệt đối.',
    xem: 'Xem',
    tinhLuc: 'Số liệu tính lúc',
    docTuBoDem: 'Số liệu đọc từ bộ đệm trạng thái, làm mới 60 giây.',
  },

  /* ------------------------------ MH-02 ---------------------------------- */
  thietBi: {
    tieuDeDanhSach: 'Danh sách thiết bị',
    moChiTiet: 'Mở chi tiết',
    dieuKhienNhanh: 'Điều khiển',
    khaiBaoMoi: 'Khai báo thiết bị',
    nhapKhau: 'Nhập khẩu hàng loạt',
    banDo: 'Bản đồ thiết bị',
    cot: {
      chon: 'Chọn dòng',
      tenThietBi: 'Tên thiết bị',
      diaBan: 'Địa bàn',
      nhaCungCap: 'Nhà cung cấp',
      trangThai: 'Trạng thái',
      amLuong: 'Âm lượng',
      noiDungPhat: 'Nội dung đang phát',
      capNhatLuc: 'Cập nhật lúc',
      hanhDong: 'Hành động',
    },
    loc: {
      trangThai: 'Trạng thái',
      nhaCungCap: 'Nhà cung cấp',
      phuongThucKetNoi: 'Phương thức kết nối',
      diaBan: 'Xã, phường',
      phienBan: 'Phiên bản phần mềm',
      trangThaiQuanLy: 'Trạng thái quản lý',
      tatCa: 'Tất cả',
    },
    ketNoi: {
      truc_tiep: 'Trực tiếp',
      gian_tiep: 'Gián tiếp',
    },
    quanLy: {
      active: 'Đang dùng',
      inactive: 'Ngừng dùng',
    },
    hangLoat: {
      dieuKhien: 'Điều khiển {so} thiết bị',
      xuatExcel: 'Xuất Excel',
      ganDiaBan: 'Gán địa bàn',
      capNhatFirmware: 'Tạo đợt cập nhật firmware',
      chuaLam: 'Chức năng này thuộc đợt sau, chưa mở ở bản này.',
    },
  },

  /* ------------------------------ MH-03 ---------------------------------- */
  chiTiet: {
    ve: 'Danh sách thiết bị',
    tab: {
      chung: 'Thông tin chung',
      trangThai: 'Trạng thái',
      nhatKy: 'Nhật ký',
      baoTri: 'Bảo trì',
    },
    sua: 'Sửa',
    maThietBi: 'Mã thiết bị',
    diaBan: 'Địa bàn',
    nhaCungCap: 'Nhà cung cấp',
    phuongThucKetNoi: 'Phương thức kết nối',
    boTuongThich: 'Bộ tương thích',
    maThamChieu: 'Mã tham chiếu bên nhà cung cấp',
    phienBanUngDung: 'Phiên bản ứng dụng',
    congSuat: 'Công suất',
    amLuong: 'Âm lượng',
    nhietDo: 'Nhiệt độ',
    dungLuong: 'Dung lượng đã dùng',
    viTri: 'Vị trí',
    xemTrenBanDo: 'Xem trên bản đồ',
    bat: 'Bật',
    tat: 'Tắt',
    doC: 'độ C',
    kb: 'KB',
    chuaCo: 'chưa khai báo',
    khoangThoiGian: 'Khoảng thời gian',
    doPhanGiai: 'Độ phân giải dữ liệu đang hiển thị',
    doPhanGiaiTho: 'dữ liệu thô',
    doPhanGiaiGio: 'tổng hợp theo giờ',
    doPhanGiaiNgay: 'tổng hợp theo ngày',
    gio24: '24 giờ',
    ngay7: '7 ngày',
    ngay90: '90 ngày',
    loaiNhatKy: 'Loại nhật ký',
    nhatKyDieuKhien: 'Nhật ký điều khiển',
    nhatKyPhat: 'Nhật ký phát',
    nhatKyLichPhat: 'Nhật ký lịch phát',
    traTheoGoiTin: 'Tra theo mã gói tin',
    baoTriThieuBang:
      'Lịch sử bảo trì đầy đủ (MH-10) thuộc đợt sau. Bản này hiển thị các sự kiện vòng đời suy được từ bản ghi thiết bị.',
    suKien: {
      kich_hoat: 'Kích hoạt lần đầu',
      thay_the: 'Thay thế thiết bị',
    },
  },

  /* ------------------------------ MH-04 ---------------------------------- */
  bieuMau: {
    tieuDeTao: 'Khai báo thiết bị mới',
    tieuDeSua: 'Sửa thông tin thiết bị',
    nhom: {
      dinhDanh: 'Định danh',
      diaBan: 'Địa bàn',
      ketNoi: 'Kết nối',
      thongSo: 'Thông số kỹ thuật',
    },
    truong: {
      cumLoaId: 'Mã thiết bị',
      tenThietBi: 'Tên thiết bị',
      loaiThietBi: 'Loại thiết bị',
      nguonId: 'Xã, phường hoặc đặc khu',
      maThon: 'Thôn hoặc tổ dân phố',
      diaChiLapDat: 'Địa chỉ lắp đặt',
      viDo: 'Vĩ độ',
      kinhDo: 'Kinh độ',
      maNhaCungCap: 'Nhà cung cấp',
      tenNhaSanXuat: 'Nhà sản xuất',
      phuongThucKetNoi: 'Phương thức kết nối',
      adapterId: 'Bộ tương thích',
      externalDeviceRef: 'Mã tham chiếu bên hệ thống nhà cung cấp',
      diaChiMac: 'Địa chỉ MAC',
      diaChiIp: 'Địa chỉ IP',
      sim: 'Số SIM',
      thoiDiemLapDat: 'Ngày lắp đặt',
      trangThai: 'Trạng thái quản lý',
    },
    batBuoc: 'bắt buộc',
    chon: 'Chọn',
    luu: 'Lưu',
    dangLuu: 'Đang lưu...',
    huy: 'Hủy',
    daLuu: 'Đã lưu thay đổi',
    daTao: 'Đã khai báo thiết bị',
    khongSuaMa: 'Thiết bị đã gửi gói tin trạng thái nên không sửa được mã thiết bị.',
    ghiChuGianTiep:
      'Kết nối gián tiếp: lệnh và dữ liệu đi qua service của nhà cung cấp, nên bắt buộc khai bộ tương thích và mã tham chiếu.',
    ghiChuTrucTiep:
      'Kết nối trực tiếp: thiết bị nói MQTT với hệ thống nguồn, thông tin xác thực và danh sách topic cấp ở màn hình MH-38 (đợt sau).',
    loiTruongBatBuoc: 'Trường này là bắt buộc',
    loiMaDiaBan: 'Mã xã phải theo dạng Hxx.yyy, ví dụ H55.101',
    conThayDoiChuaLuu: 'Còn {so} thay đổi chưa lưu. Bạn muốn làm gì?',
    tiepTucSua: 'Tiếp tục sửa',
    luuRoiRoi: 'Lưu rồi rời trang',
    roiVaBo: 'Rời trang và bỏ thay đổi',
  },

  /* ------------------------------ MH-05 ---------------------------------- */
  banDo: {
    tieuDe: 'Bản đồ thiết bị',
    gomNhom: 'Đang gom nhóm theo mật độ. Phóng to để thấy từng thiết bị.',
    tungThietBi: 'Đang hiển thị từng thiết bị trong khung nhìn.',
    khungNhin: 'Khung nhìn',
    phongTo: 'Phóng to',
    thuNho: 'Thu nhỏ',
    diChuyen: 'Di chuyển khung nhìn',
    mucThuPhong: 'Mức thu phóng',
    khongCoToaDo: 'Thiết bị chưa có tọa độ',
    khongCoToaDoNhac: 'Những thiết bị này không hiện trên bản đồ. Hãy bổ sung tọa độ ở biểu mẫu khai báo.',
    soThietBi: 'thiết bị',
    trucTuyen: 'trực tuyến',
    taiTheoKhungNhin: 'Chỉ tải thiết bị trong khung nhìn, độ trễ 500 mili giây.',
  },

  /* ------------------------------ MH-06 ---------------------------------- */
  nhapKhau: {
    tieuDe: 'Nhập khẩu hàng loạt thiết bị',
    buoc1: 'Tải tệp',
    buoc2: 'Đối chiếu cột',
    buoc3: 'Kiểm tra',
    buoc4: 'Xác nhận',
    chonTep: 'Chọn tệp CSV',
    tepMau: 'Tải tệp mẫu',
    gioiHan: 'Tối đa 5.000 dòng một lần.',
    tiepTuc: 'Tiếp tục',
    quayLai: 'Quay lại',
    cotTrongTep: 'Cột trong tệp',
    truongHeThong: 'Trường hệ thống',
    boQua: 'Bỏ qua cột này',
    nhoAnhXa: 'Đã áp dụng ánh xạ cột của lần nhập trước.',
    ketQuaKiemTra: 'Kết quả kiểm tra {so} dòng',
    hopLe: 'Hợp lệ',
    canhBao: 'Cảnh báo',
    loi: 'Lỗi',
    cotDong: 'Dòng',
    cotMa: 'Mã thiết bị',
    cotKetQua: 'Kết quả',
    cotLyDo: 'Lý do',
    cotCot: 'Cột',
    taiTepLoi: 'Tải tệp lỗi',
    nhapSoDong: 'Nhập {so} dòng hợp lệ',
    ghiChuCanhBao: 'Dòng cảnh báo vẫn được nhập, dòng lỗi bị loại.',
    daNhap: 'Đã nhập {so} dòng.',
    dangNhap: 'Đang nhập...',
    loiDocTep: 'Không đọc được tệp. Tệp phải là CSV có dòng tiêu đề cột.',
  },

  /* ------------------------------ MH-08 ---------------------------------- */
  dieuKhien: {
    tieuDe: 'Điều khiển thiết bị',
    soThietBi: '{so} thiết bị đã chọn',
    dong: 'Đóng ngăn điều khiển',
    nhieuGiaTri: 'nhiều giá trị',
    lenh: {
      amLuong: 'Âm lượng',
      congSuat: 'Công suất',
      dungPhat: 'Dừng phát',
      khoiDongLai: 'Khởi động lại',
      nangCap: 'Nâng cấp phiên bản',
    },
    moTaCongSuat: 'Tắt công suất làm thiết bị ngừng phát ra loa. Đây không phải lệnh dừng phát bản tin.',
    dungPhatLuaChon: {
      tatCa: 'Dừng tất cả',
      hienThoi: 'Dừng bản tin hiện thời',
      tamDung: 'Tạm dừng',
      phatTiep: 'Phát tiếp',
    },
    khoiDongLaiTre: 'Số giây trễ',
    nangCapChon: 'Chọn bản firmware',
    nangCapChuyenMH09:
      'Trên 50 thiết bị, cập nhật firmware là một đợt cần theo dõi nên thực hiện ở màn hình MH-09 (đợt sau).',
    gui: 'Gửi lệnh',
    dangGui: 'Đang gửi lệnh...',
    ghiChuGianTiep:
      'Trong số thiết bị đã chọn có {so} thiết bị kết nối GIÁN TIẾP. Lệnh được chuyển qua service của nhà cung cấp, nên thời gian phản hồi phụ thuộc cam kết của nhà cung cấp đó.',
    xacNhanTieuDe: 'Xác nhận gửi lệnh',
    xacNhanKhoiDongLai:
      'Lệnh khởi động lại sẽ áp dụng cho {so} thiết bị. Các thiết bị này KHÔNG phát được trong khoảng thời gian khởi động lại.',
    xacNhanAmLuong: 'Đặt âm lượng {thamSo} cho {so} thiết bị.',
    xacNhanCongSuat: 'Đặt công suất {thamSo} cho {so} thiết bị.',
    xacNhanDungPhat: 'Áp dụng lệnh dừng phát cho {so} thiết bị.',
    tienTrinhTieuDe: 'Tiến trình theo từng thiết bị',
    moc: {
      da_nhan_lenh: 'Hệ thống đã nhận lệnh',
      ncc_da_nhan: 'Service nhà cung cấp đã nhận',
      thiet_bi_da_xac_nhan: 'Thiết bị đã xác nhận',
      loi: 'Lỗi',
    },
    mocGhiChu:
      'Mốc "service nhà cung cấp đã nhận" là mốc hệ thống nguồn biết chắc, khác với mốc thiết bị thực sự thực hiện lệnh.',
  },

  /* ------------- Kết quả thao tác hàng loạt: ba nhóm bắt buộc ------------- */
  ketQuaLo: {
    tieuDe: 'Kết quả thao tác',
    thanhCong: 'Thành công',
    dangCho: 'Đang chờ',
    loi: 'Lỗi',
    danhSachLoi: 'Danh sách thiết bị lỗi',
    thuLaiPhanLoi: 'Thử lại {so} thiết bị lỗi',
    dangThuLai: 'Đang thử lại...',
    ghiChuThuLai: 'Thử lại chỉ áp dụng cho các thiết bị ở nhóm lỗi.',
    maThietBi: 'Mã thiết bị',
    maLoi: 'Mã lỗi',
    lyDo: 'Lý do',
    dong: 'Đóng',
  },

  /* ------------------------- Hộp thoại xác nhận 3.4 ----------------------- */
  xacNhan: {
    huy: 'Hủy',
    thucHien: 'Thực hiện',
    tuXacNhan: 'Nhập từ "{tu}" để bật nút thực hiện',
    tuXacNhanNhan: 'Từ xác nhận',
    xoaTu: 'XOA',
    xoaTieuDe: 'Xóa thiết bị',
    xoaMoTa:
      'Thao tác này xóa {so} thiết bị khỏi danh sách quản lý và KHÔNG hoàn tác được. Toàn bộ nhật ký phát của thiết bị vẫn được giữ lại.',
  },

  chung: {
    dong: 'Đóng',
    loi: 'Lỗi',
    canhBao: 'Cảnh báo',
    khong: 'Không',
    co: 'Có',
  },

  /* --------------------- 3.7 Trình phát âm thanh dùng chung --------------------- */
  trinhPhat: {
    phat: 'Phát',
    tamDung: 'Tạm dừng',
    tocDo: 'Tốc độ phát',
    dangTai: 'Đang tải âm thanh…',
    loi: 'Không phát được tệp âm thanh này',
    cheDoLuong: 'Đang phát trực tiếp',
    doTre: 'Độ trễ luồng',
    dongBoLai: 'Đồng bộ lại về thời điểm hiện tại',
    daNgheHet: 'Đã nghe hết một lần',
    phimTat: 'Phím cách để phát hoặc tạm dừng',
  },

  /* ------------------------------- MH-11 Danh sách bản tin ------------------------------- */
  banTin: {
    tieuDe: 'Danh sách bản tin',
    taoMoi: 'Tạo bản tin',
    taoTuVanBan: 'Tạo từ văn bản',
    timKiem: 'Tìm theo tiêu đề hoặc nội dung',
    trangThai: 'Trạng thái',
    linhVuc: 'Lĩnh vực',
    diaBan: 'Địa bàn áp dụng',
    nguoiTao: 'Người tạo',
    tuNgay: 'Từ ngày',
    denNgay: 'Đến ngày',
    cot: {
      tieuDe: 'Tiêu đề',
      trangThai: 'Trạng thái',
      nguonGoc: 'Nguồn gốc',
      diaBanApDung: 'Địa bàn áp dụng',
      lanPhatGanNhat: 'Lần phát gần nhất',
      hanhDong: 'Hành động',
    },
    trangThaiNhan: {
      tao_moi: 'Đang thực hiện',
      chua_duyet: 'Chờ duyệt',
      da_duyet: 'Đã duyệt',
      // Theo quy ước của tỉnh (05/10/2026): người dùng chỉ thấy Đang thực hiện → Chờ duyệt →
      // Đã duyệt; bản tin đã duyệt rồi đưa vào phát (dang_phat/da_phat) vẫn hiện "Đã duyệt".
      dang_phat: 'Đã duyệt',
      da_phat: 'Đã duyệt',
      da_huy: 'Đã hủy',
    },
    /** Lựa chọn ô lọc Trạng thái: "Đã duyệt" gồm cả bản tin đang/đã đưa vào phát. */
    locTrangThai: [
      { giaTri: 'tao_moi', nhan: 'Đang thực hiện' },
      { giaTri: 'chua_duyet', nhan: 'Chờ duyệt' },
      { giaTri: 'da_duyet,dang_phat,da_phat', nhan: 'Đã duyệt' },
      { giaTri: 'da_huy', nhan: 'Đã hủy' },
    ],
    nguonGocNhan: {
      tu_bien_tap: 'Tự biên tập',
      chuyen_van_ban: 'Chuyển văn bản thành giọng nói',
      tiep_song: 'Tiếp sóng',
      trung_uong: 'Nhận từ trung ương',
    },
    /** Đúng enum `LoaiLinhVuc` của OpenAPI (mục 180-193): sáu mã '1'..'6'. */
    linhVucNhan: {
      '1': 'Thông tin chung',
      '2': 'Thông tin đột xuất',
      '3': 'Đường lối, chủ trương, chính sách, pháp luật',
      '4': 'Chỉ đạo, điều hành của cấp ủy, chính quyền cơ sở',
      '5': 'Kiến thức khoa học, kỹ thuật, kinh tế, văn hóa, xã hội',
      '6': 'Gương người tốt, việc tốt',
    },
    ngheThu: 'Nghe thử',
    moBienTap: 'Mở biên tập',
    guiDuyet: 'Gửi duyệt',
    lapLich: 'Lập lịch phát',
    nhanBan: 'Nhân bản',
    daNhanBan: 'Đã nhân bản thành bản tin mới ở trạng thái tạo mới',
    rongMoTa: 'Chưa có bản tin nào trong phạm vi địa bàn đang xem. Bắt đầu bằng cách tạo bản tin mới.',
    khaiBaoMoi: 'Tạo bản tin đầu tiên',
    chuaCo: '—',
    soThietBiPhat: '{thanhCong}/{tong} thiết bị',
  },

  /* ------------------------------- MH-12 Biên tập bản tin ------------------------------- */
  bienTap: {
    tieuDeMoi: 'Bản tin mới',
    nhanTieuDe: 'Tiêu đề',
    nhanLinhVuc: 'Lĩnh vực',
    nhanMucDoUuTien: 'Mức độ ưu tiên',
    nhanPhamVi: 'Phạm vi địa bàn',
    chonPhamVi: 'Chọn',
    chuaChonPhamVi: 'Chưa chọn phạm vi',
    nhanDiaBanTao: 'Địa bàn tạo (theo đơn vị đăng nhập, chỉ đọc)',
    nhanNoiDung: 'Nội dung văn bản',
    nhanTomTat: 'Tóm tắt',
    cauTaoAmThanh: 'Cấu tạo âm thanh',
    tongThoiLuong: 'Tổng thời lượng',
    doanRong:
      'Chưa có đoạn âm thanh nào. Tải tệp, chọn từ kho, hoặc tạo bằng chuyển văn bản thành giọng nói.',
    themTuTep: 'Tải tệp',
    themTuKho: 'Từ kho',
    themTuTts: 'Tổng hợp giọng nói',
    diChuyenLen: 'Di chuyển lên',
    diChuyenXuong: 'Di chuyển xuống',
    xoaDoan: 'Xóa đoạn',
    ngheThuToanBo: 'Nghe thử toàn bộ',
    dinhDangSai: 'Chỉ nhận tệp mp3 và wav',
    luuNhap: 'Lưu nháp',
    xemTruoc: 'Xem trước',
    guiDuyet: 'Gửi duyệt',
    daLuuNhapLuc: 'Đã lưu nháp {luc}',
    dangLuu: 'Đang lưu…',
    canhBaoRoiTrang: 'Bản tin có thay đổi chưa lưu. Bạn có chắc muốn rời màn hình?',
    dieuKienGuiDuyet:
      'Nút gửi duyệt chỉ bật khi cấu tạo âm thanh có ít nhất một đoạn. Phạm vi phát được chọn riêng khi lập lịch, phát ngay hoặc phát khẩn cấp.',
    dangGhepAmThanh: 'Đang xử lý âm thanh…',
    ghepXong: 'Đã ghép xong âm thanh, có thể nghe thử bản đã ghép',
    daGuiDuyet: 'Đã gửi duyệt',
    chuanHoaGhiChu: 'Bản tin sẽ được chuẩn hóa mức âm và tần số lấy mẫu khi ghép các đoạn.',
  },

  /* ------------------------------ MH-14 Hàng đợi duyệt ------------------------------ */
  duyet: {
    tieuDe: 'Hàng đợi duyệt bản tin',
    coDuyet: 'Duyệt',
    yeuCauSua: 'Yêu cầu sửa',
    tuChoi: 'Từ chối',
    nhanYKien: 'Ý kiến',
    yKienBatBuoc: 'Ý kiến là bắt buộc cho hành động này',
    lyDoBatBuoc: 'Lý do là bắt buộc cho hành động này',
    xacNhanDaNghe: 'Xác nhận đã nghe',
    dieuKienDuyet:
      'Phải nghe hết ít nhất một lần, hoặc bấm xác nhận đã nghe, trước khi nút duyệt được kích hoạt',
    chuaNghe: 'Chưa nghe bản tin này',
    daNghe: 'Đã nghe',
    nhatKyDuyet: 'Lịch sử chỉnh sửa và duyệt',
    rongMoTa: 'Không có bản tin nào đang chờ duyệt trong phạm vi địa bàn đang xem.',
    quayLaiHangDoi: 'Quay lại hàng đợi',
    daGhiNhanQuyetDinh: 'Đã ghi nhận quyết định duyệt',
  },

  /* -------------------------------- MH-17/18 Lịch phát ------------------------------- */
  lichPhat: {
    tieuDe: 'Lịch phát',
    tuanTruoc: 'Tuần trước',
    tuanSau: 'Tuần sau',
    taoLichPhat: 'Tạo lịch phát',
    xungDot: 'Xung đột thời gian',
    xungDotGiaiThich:
      'Trùng khung giờ trên cùng địa bàn với "{ten}", mức ưu tiên {uuTien}: "{thang}" sẽ thực thi.',
    trangThaiNhan: { hieu_luc: 'Hiệu lực', da_huy: 'Đã hủy' },
    nhanBanTin: 'Bản tin phát',
    nhanPhamVi: 'Phạm vi địa bàn',
    nhanThoiDiemPhat: 'Thời điểm phát',
    themKhungGio: 'Thêm khung giờ',
    xoaKhungGio: 'Xóa khung giờ',
    nhanLapLai: 'Lặp lại',
    khongLap: 'Không lặp',
    lapTheoNgayTrongTuan: 'Lặp theo ngày trong tuần',
    lapTheoKhoangNgay: 'Lặp theo khoảng ngày',
    nhanNgayBatDau: 'Ngày bắt đầu',
    nhanNgayKetThuc: 'Ngày kết thúc',
    nhanMucDoUuTien: 'Mức độ ưu tiên của lịch',
    uuTienNhan: { '1': 'Khẩn cấp', '2': 'Ưu tiên', '3': 'Thường' },
    uuTienGiaiThich:
      'Khi hai lịch trùng khung giờ trên cùng địa bàn, lịch có mức ưu tiên cao hơn sẽ thực thi.',
    banTinChuaDuyet:
      'Bản tin này chưa được duyệt: lịch phát sẽ không thực thi cho tới khi bản tin ở trạng thái đã duyệt.',
    guiDuyetNgay: 'Gửi duyệt ngay',
    luu: 'Lưu lịch phát',
    huy: 'Hủy',
    quaKhu: 'Không thể lưu lịch phát trong quá khứ; thời điểm gần nhất có thể chọn là {luc}',
    rongMoTa: 'Chưa có lịch phát nào trong phạm vi và khoảng thời gian đang xem.',
  },

  /* ------------------------- MH-19/20/22/23 Điều hành phát ------------------------- */
  phatSong: {
    phatNgayTieuDe: 'Phát ngay',
    buoc1ChonBanTin: 'Bước 1: chọn bản tin đã duyệt',
    buoc2ChonPhamVi: 'Bước 2: chọn phạm vi địa bàn',
    buoc3XacNhan: 'Bước 3: xác nhận',
    soCumTrongPhamVi: 'Phát tới {so} cụm loa',
    soCumDangPhatKhac: 'Đang chiếm quyền phát tại {so} cụm loa đang phát nội dung khác',
    xacNhanPhat: 'Xác nhận phát',
    daGuiLenhPhat: 'Đã gửi lệnh phát, đang chuyển sang theo dõi phiên phát',

    khanCapTieuDe: 'Phát bản tin khẩn cấp — chiếm quyền phát trên địa bàn',
    khanCapChiDanhChoQuyen: 'Màn hình này chỉ dành cho người dùng có quyền phát khẩn cấp.',
    nguonPhat: 'Nguồn phát',
    nguonBanTinDaDuyet: 'Bản tin đã duyệt',
    nguonTrucTiepMicro: 'Phát trực tiếp qua micro',
    soLanLap: 'Lặp lại',
    khoangCachLap: 'Khoảng cách giữa các lần',
    heQuaTieuDe: 'Hệ quả',
    heQuaPhatToi: 'Phát tới {so} cụm loa trên {soXa} xã',
    heQuaChiemQuyen: 'Chiếm quyền phát đang thực hiện tại {so} cụm loa',
    heQuaHuyLich: '{so} lịch phát đang trong khung giờ bị chen ngang (lịch không bị hủy)',
    heQuaGianTiep: '{so} cụm loa kết nối gián tiếp, phụ thuộc thời gian phản hồi của nhà cung cấp',
    heQuaDangTai: 'Đang tính bản kê hệ quả…',
    tuXacNhanKhanCap: 'KHANCAP',
    nhapTuXacNhan: 'Nhập {tu} để xác nhận',
    thucHien: 'Thực hiện',
    huy: 'Hủy',
    daChuyenSangTheoDoi: 'Đã gửi lệnh phát khẩn cấp, đang chuyển sang theo dõi trực tiếp',

    theoDoiTieuDe: 'Theo dõi phiên phát',
    nhomDaXacNhan: 'Đã xác nhận phát',
    nhomChoXacNhan: 'Chờ xác nhận',
    nhomLoi: 'Lỗi',
    tongSoThietBi: 'Tổng số thiết bị ước tính',
    thoiDiemGui: 'Thời điểm gửi lệnh',
    xemLyDo: 'Xem lý do',
    thuLai: 'Thử lại',
    dangCapNhat: 'Đang cập nhật mỗi {giay} giây',
    duyNhatDuoi5s: 'Đây là màn hình duy nhất được làm mới dưới 5 giây.',
    rongMoTa: 'Chưa có thiết bị nào trong phiên phát này.',

    /* -------------------- MH-22 Phát trực tiếp qua micro -------------------- */
    trucTiepTieuDe: 'Phát trực tiếp qua micro',
    buoc1ChonPhamViMicro: 'Bước 1: chọn phạm vi địa bàn',
    buoc2KiemTraMic: 'Bước 2: kiểm tra thiết bị đầu vào',
    buoc3BangDieuKhien: 'Bước 3: bảng điều khiển phiên phát',
    khongCoMic:
      'Trình duyệt không cho phép hoặc không tìm thấy micro. Kiểm tra quyền truy cập micro của trình duyệt.',
    mucAmThuDuoc: 'Mức âm thu được',
    moPhien: 'Mở phiên phát',
    ketThucPhien: 'Kết thúc phiên',
    tatTiengTam: 'Tắt tiếng tạm thời',
    batTiengLai: 'Bật tiếng lại',
    thoiLuongPhien: 'Thời lượng phiên',
    dangMoPhien: 'Đang mở phiên…',
    daKetThucPhien: 'Đã kết thúc phiên. Bản ghi có thể tra cứu lại ở màn hình nghe lại bản tin đã phát.',
    ghiChuLuonGhiAm: 'Phiên phát trực tiếp luôn được ghi lại và trở thành một bản ghi tra cứu được.',

    /* ------------------------------- MH-21 Tiếp sóng ------------------------------- */
    tiepSongTieuDe: 'Tiếp sóng và tiếp âm',
    tiepSongGhiChu:
      'Hệ thống thu MỘT bản ở cấp tỉnh rồi phân phối lại cho các thiết bị, không để từng xã tự thu cùng một luồng.',
    tenNguon: 'Tên nguồn',
    loaiNguon: 'Loại',
    diaChiNguon: 'Địa chỉ luồng / tần số',
    phamViApDung: 'Địa bàn áp dụng',
    trangThaiThu: 'Trạng thái thu',
    dangThu: 'Đang thu',
    khongThu: 'Không thu',
    mucAm: 'Mức âm',
    canhBaoImLang: 'Luồng im lặng',
    capNhatLuc: 'Cập nhật lúc',
    khaiBaoNguonMoi: 'Khai báo nguồn mới',
    batDauTiepSong: 'Bắt đầu tiếp sóng',
    loaiHls: 'Luồng số hóa (HLS)',
    loaiIcy: 'Luồng số hóa (Icecast)',
    loaiRtmp: 'Luồng số hóa (RTMP)',
    loaiFm: 'Tiếp âm FM',
    rongMoTaTiepSong: 'Chưa khai báo nguồn tiếp sóng/tiếp âm nào.',
  },

  /* --------------------------- MH-13 Tạo bản tin từ văn bản --------------------------- */
  taoTuVanBan: {
    tieuDe: 'Tạo bản tin từ văn bản',
    nhanVanBan: 'Nội dung văn bản',
    nhanGiongDoc: 'Giọng đọc',
    nhanTocDo: 'Tốc độ đọc',
    xemTruoc200: 'Bản nghe thử (200 ký tự đầu)',
    taoNgheThu: 'Tạo bản nghe thử',
    dangTaoNgheThu: 'Đang tổng hợp bản nghe thử…',
    tongHopToanVan: 'Tổng hợp toàn văn',
    dangTongHop: 'Đang tổng hợp trong nền — có thể rời màn hình, hệ thống báo khi xong',
    daXongThongBao: 'Đã tổng hợp xong giọng nói, đoạn âm thanh đã được thêm vào bản tin',
    loiTongHop: 'Tổng hợp thất bại',
    bangCachDoc: 'Bảng thay thế cách đọc',
    bangCachDocMoTa:
      'Khai báo cách đọc riêng cho từ viết tắt, tên riêng địa bàn và số liệu đặc thù (ví dụ "UBND" → "Uỷ ban nhân dân"), áp dụng trước khi tổng hợp giọng nói.',
    tuGoc: 'Từ',
    cachDoc: 'Đọc thành',
    themDong: 'Thêm dòng',
    xoaDong: 'Xóa',
    chonBanTin: 'Bản tin đích',
    guiVaoBanTin: 'Sau khi tổng hợp xong, đoạn âm thanh sẽ được thêm vào cấu tạo âm thanh của bản tin này.',
  },

  /* --------------------------------- MH-15 Kho âm thanh -------------------------------- */
  khoAmThanh: {
    tieuDe: 'Kho âm thanh',
    timKiem: 'Tìm theo tên tệp',
    nhom: 'Nhóm',
    the: 'Thẻ',
    cot: {
      ten: 'Tên tệp',
      nhom: 'Nhóm',
      thoiLuong: 'Thời lượng',
      kichThuoc: 'Kích thước',
      soThamChieu: 'Số lần được dùng',
      hanhDong: 'Hành động',
    },
    taiLenMoi: 'Tải tệp mới',
    ngheThu: 'Nghe thử',
    xoa: 'Xóa',
    khongXoaDuocDangDung: 'Tệp đang được {so} bản tin dùng, không xóa được',
    rongMoTa: 'Kho âm thanh chưa có tệp nào.',
    dinhDangSai: 'Chỉ nhận tệp mp3 và wav',
  },

  /* ------------------------- MH-16 Nghe lại bản tin đã phát ------------------------ */
  ngheLai: {
    tieuDe: 'Nghe lại bản tin đã phát',
    cot: {
      banTin: 'Bản tin',
      thoiDiem: 'Thời điểm phát',
      thietBi: 'Thiết bị',
      ketQua: 'Trạng thái',
      nguon: 'Nguồn xác nhận',
    },
    rongMoTa: 'Chưa có lần phát nào phù hợp với bộ lọc trong ba tháng gần nhất.',
    ghiChuTiepAm:
      'Đây là bản tin tiếp sóng: bản ghi là bản thu ở cấp tỉnh, không phải bản ghi âm tại từng thiết bị.',
    dongY: 'Đóng',
    khongCoAmThanh: 'Không lấy được tệp âm thanh của lần phát này.',
  },

  /* --------------------------------- MH-32 Báo cáo định kỳ -------------------------------- */
  baoCaoDinhKy: {
    tieuDe: 'Báo cáo định kỳ',
    taoKyMoi: 'Tạo kỳ báo cáo',
    maBaoCao: 'Mã báo cáo',
    quy: 'Quý',
    nam: 'Năm',
    tao: 'Tạo',
    huy: 'Hủy',
    cot: {
      maBaoCao: 'Mã báo cáo',
      ky: 'Kỳ',
      trangThai: 'Trạng thái',
      nguoiDuyet: 'Người chốt',
      chotLuc: 'Thời điểm chốt',
      guiLuc: 'Thời điểm gửi',
    },
    trangThai: {
      nhap: 'Đang nhập',
      da_duyet: 'Đã chốt',
      da_gui: 'Đã gửi trung ương',
    },
    rongMoTa: 'Chưa có kỳ báo cáo nào. Tạo kỳ mới để bắt đầu.',
    chiTietTieuDe: 'Chi tiết kỳ báo cáo',
    dong: 'Đóng',
    tongHopLai: 'Tổng hợp lại số liệu',
    xuatBieuMau: 'Xuất biểu mẫu',
    chotKy: 'Chốt kỳ',
    moLaiKy: 'Mở lại kỳ',
    xacNhanChot: 'Sau khi chốt, kỳ báo cáo chỉ đọc và không sửa được nữa. Xác nhận chốt kỳ?',
    lyDoMoLai: 'Lý do mở lại kỳ đã chốt (bắt buộc, sẽ được ghi vào nhật ký)',
    khongCoQuyenMoLai: 'Cần quyền riêng để mở lại kỳ đã chốt.',
    chiTieuCot: {
      tenChiTieu: 'Chỉ tiêu',
      giaTriHeThong: 'Hệ thống tự tính',
      giaTriDieuChinh: 'Điều chỉnh',
      lyDoDieuChinh: 'Lý do điều chỉnh',
      giaTriChot: 'Giá trị chốt',
    },
    suaChiTieu: 'Sửa',
    luuDieuChinh: 'Lưu điều chỉnh',
    huyDieuChinh: 'Hủy',
    canLyDo: 'Phải nhập lý do khi điều chỉnh số liệu',
    daKhoa: 'Kỳ đã chốt: chỉ đọc.',
    dangTongHop: 'Đang tổng hợp lại…',
    tongHopXong: 'Đã tổng hợp lại số liệu hệ thống.',
  },

  /* --------------------------------- MH-33 Thống kê -------------------------------- */
  thongKe: {
    tieuDe: 'Thống kê thiết bị và bản tin',
    nhom: {
      diaBan: 'Theo địa bàn',
      thoiGian: 'Theo thời gian',
      linhVuc: 'Theo lĩnh vực nội dung',
      nhaCungCap: 'Theo nhà cung cấp',
    },
    boLoc: {
      tuNgay: 'Từ ngày',
      denNgay: 'Đến ngày',
      diaBan: 'Địa bàn',
      nhaCungCap: 'Nhà cung cấp',
    },
    mucDoTongHop: {
      tho: 'dữ liệu thô (thời gian thực)',
      gio: 'tổng hợp theo giờ',
      ngay: 'tổng hợp theo ngày',
    },
    dangHienThi: 'Đang hiển thị dữ liệu {mucDo}',
    xemBangDuLieu: 'Xem bảng dữ liệu gốc',
    anBangDuLieu: 'Ẩn bảng dữ liệu gốc',
    xuatBaoCao: 'Xuất báo cáo',
    dangXuat: 'Đang xuất…',
    xuatXong: 'Xuất xong',
    xuatLoi: 'Xuất thất bại',
    taiVe: 'Tải tệp về',
    cotThietBi: {
      nguonId: 'Địa bàn',
      soThietBi: 'Số thiết bị',
      tyLeHoatDong: 'Tỷ lệ hoạt động',
    },
    cotThoiGian: {
      thoiDiem: 'Thời điểm',
      soBanTin: 'Số bản tin',
      thoiLuongGiay: 'Thời lượng (giây)',
    },
    cotLinhVuc: {
      linhVuc: 'Lĩnh vực',
      soBanTin: 'Số bản tin',
      thoiLuongGiay: 'Thời lượng (giây)',
    },
    cotNhaCungCap: {
      maNhaCungCap: 'Nhà cung cấp',
      soThietBi: 'Số thiết bị',
      tyLeHoatDong: 'Tỷ lệ hoạt động',
      tyLeLenhThanhCong: 'Tỷ lệ lệnh thành công',
      doTreTrungBinhMs: 'Độ trễ phản hồi TB (ms)',
    },
    rongMoTa: 'Không có dữ liệu phù hợp với bộ lọc trong khoảng thời gian đã chọn.',
  },

  /* ------------------------- MH-34/35 Quản trị người dùng -------------------------- */
  nguoiDung: {
    tieuDe: 'Người dùng',
    taoMoi: 'Tạo tài khoản',
    cot: {
      tenDangNhap: 'Tên đăng nhập',
      hoTen: 'Họ tên',
      email: 'Email',
      trangThai: 'Trạng thái',
      nhom: 'Nhóm quyền',
      phamViDiaBan: 'Phạm vi địa bàn',
    },
    trangThai: { active: 'Hoạt động', locked: 'Đã khoá' },
    khoa: 'Khoá tài khoản',
    moKhoa: 'Mở khoá',
    datLaiMatKhau: 'Đặt lại mật khẩu',
    matKhauMoiLa: 'Mật khẩu mới',
    tenDangNhap: 'Tên đăng nhập',
    hoTen: 'Họ tên',
    email: 'Email',
    matKhau: 'Mật khẩu (bỏ trống để hệ thống tự sinh)',
    tao: 'Tạo',
    huy: 'Huỷ',
    rongMoTa: 'Chưa có tài khoản nào.',
    daKhoa: 'Đã khoá tài khoản.',
    daMoKhoa: 'Đã mở khoá tài khoản.',
  },
  nhomQuyen: {
    tieuDe: 'Nhóm quyền',
    taoNhom: 'Tạo nhóm',
    tenNhom: 'Tên nhóm',
    soNguoiDung: 'Số người dùng',
    quyenNguyHiem: 'Bốn quyền nguy hiểm',
    ghiChuNguyHiem:
      'Quyền phát khẩn cấp, cập nhật phần mềm nền, quản trị đa tỉnh và cấp thông tin xác thực thiết bị ' +
      'có thể gây hậu quả trên diện rộng — hiển thị riêng, cần xác nhận trước khi đổi.',
    xemTruoc: 'Xem trước ảnh hưởng',
    apDung: 'Áp dụng thay đổi',
    huy: 'Huỷ',
    quyenThem: 'Sẽ THÊM',
    quyenBot: 'Sẽ BỎ',
    soNguoiBiAnhHuong: 'Số người dùng bị ảnh hưởng',
    xacNhanApDung: 'Xác nhận áp dụng thay đổi quyền cho nhóm này?',
    daApDung: 'Đã áp dụng thay đổi quyền.',
    rongMoTa: 'Chưa có nhóm quyền nào.',
    chonNhomDeXem: 'Chọn một nhóm ở danh sách bên trái để xem và sửa ma trận quyền.',
  },

  /* --------------------------- MH-36 Danh mục hành chính --------------------------- */
  danhMucHanhChinh: {
    tieuDe: 'Danh mục hành chính',
    cap: { tinh: 'Tỉnh', xa: 'Xã/Phường', thon: 'Thôn/Tổ' },
    troLyDoiTen: 'Đổi tên',
    troLySapNhap: 'Sáp nhập',
    troLyChiaTach: 'Chia tách',
    anhHuongTieuDe: 'Ảnh hưởng nếu thực hiện',
    soThietBi: 'Số thiết bị',
    soBanTin: 'Số bản tin',
    soLichPhat: 'Số lịch phát',
    xuLyLichSu: 'Xử lý dữ liệu lịch sử',
    xuLyGiuNguyen: 'Giữ nguyên mã cũ trên dữ liệu lịch sử (khuyến nghị)',
    xuLyGanLai: 'Gán lại toàn bộ dữ liệu lịch sử theo mã mới',
    tenMoi: 'Tên mới',
    maMoi: 'Mã định danh mới',
    chonDonViNguon: 'Chọn các đơn vị nguồn (cùng cấp)',
    xemTruocAnhHuong: 'Xem trước ảnh hưởng',
    xacNhanThucHien: 'Xác nhận thực hiện',
    huy: 'Huỷ',
    daThucHien: 'Đã thực hiện.',
    khongTheSuaMaTrucTiep: 'Không thể sửa trực tiếp mã định danh vì đang có thiết bị gắn theo mã này.',
    suaTen: 'Sửa tên hiển thị',
    luu: 'Lưu',
    rongMoTa: 'Chưa có đơn vị hành chính nào.',
    rongHuongDan: 'Bấm "Nhập từ tệp" để nạp danh mục xã/phường, thôn/tổ dân phố của tỉnh.',
    nhapTuTep: 'Nhập từ tệp',
    nhapTieuDe: 'Nhập danh mục hành chính từ tệp',
    nhapMoTa:
      'Chọn tệp CSV (Excel: "Lưu thành → CSV UTF-8"; Google Sheets: "Tải xuống → CSV"). Nhận hai dạng cột: bảng mã quốc gia MDD_01, TEN_01, MDD_02, TEN_02, CAP_TEN_02… hoặc ma_dinh_danh, ten, cap, ma_cha.',
    taiTepMau: 'Tải tệp mẫu',
    chonTep: 'Tệp danh mục (.csv)',
    khongNhanRaCot:
      'Không nhận ra cột của tệp. Cần cột MDD_02/TEN_02 (bảng mã quốc gia) hoặc ma_dinh_danh/ten.',
    tepRong: 'Tệp không có dòng dữ liệu nào.',
    dangDoc: 'Đang đọc tệp…',
    ketQuaXemTruoc: 'Kết quả kiểm tra tệp',
    soDongTep: 'Số đơn vị đọc được',
    soThemMoi: 'Sẽ thêm mới',
    soDaCo: 'Đã có, trùng tên (bỏ qua)',
    soKhacTen: 'Đã có nhưng khác tên (không tự đổi — dùng trợ lý Đổi tên)',
    soLoi: 'Dòng lỗi (bỏ qua)',
    tuThemTinh: 'Sẽ tự thêm đơn vị cấp tỉnh {ma} làm gốc cây.',
    dongLoi: 'Dòng {dong} ({ma}): {loi}',
    nhapXacNhan: 'Nhập {so} đơn vị',
    daNhap: 'Đã thêm {so} đơn vị hành chính vào danh mục.',
    khongCoGiThem: 'Không có đơn vị mới nào để thêm.',
  },
  linhVucBanTin: {
    tieuDe: 'Lĩnh vực bản tin',
    themMoi: 'Thêm lĩnh vực',
    cot: { ma: 'Mã', ten: 'Tên', trangThai: 'Trạng thái', macDinh: 'Mặc định' },
    trangThai: { hoat_dong: 'Đang sử dụng', ngung_su_dung: 'Ngừng sử dụng' },
    ngungSuDung: 'Ngừng sử dụng',
    kichHoatLai: 'Kích hoạt lại',
    xoa: 'Xoá',
    khongXoaDuocMacDinh: 'Không xoá được lĩnh vực mặc định — chỉ chuyển ngừng sử dụng.',
    ma: 'Mã',
    ten: 'Tên',
    anhXa: 'Ánh xạ loại lĩnh vực báo cáo',
    tao: 'Thêm',
    huy: 'Huỷ',
    rongMoTa: 'Chưa có lĩnh vực bản tin nào.',
  },

  /* -------------------------------- MH-38 Nhật ký thao tác -------------------------------- */
  nhatKyThaoTac: {
    tieuDe: 'Nhật ký thao tác',
    ghiChuChiDoc: 'Chỉ đọc — không có chức năng sửa hay xoá, kể cả với vai trò quản trị nền tảng.',
    boLoc: {
      nguoiThucHien: 'Người thực hiện',
      maThaoTac: 'Loại hành động',
      loaiDoiTuong: 'Loại đối tượng',
      maDoiTuong: 'Mã đối tượng',
      diaBan: 'Địa bàn',
      tuThoiDiem: 'Từ ngày',
      denThoiDiem: 'Đến ngày',
    },
    cot: {
      thoiDiem: 'Thời điểm',
      tenDangNhap: 'Người thực hiện',
      maThaoTac: 'Hành động',
      doiTuong: 'Đối tượng',
      ketQua: 'Kết quả',
      chiTiet: 'Chi tiết',
    },
    xemChiTiet: 'Xem trước/sau',
    giaTriTruoc: 'Giá trị trước',
    giaTriSau: 'Giá trị sau',
    dong: 'Đóng',
    rongMoTa: 'Không có dòng nhật ký phù hợp với bộ lọc.',
  },

  /* ----------------------------- MH-39 Quản trị đa tỉnh ----------------------------- */
  daTinh: {
    tieuDe: 'Quản trị đa tỉnh',
    cot: {
      tenTinh: 'Tỉnh',
      soThietBi: 'Số thiết bị',
      soNguoiDung: 'Số người dùng',
      soDonViHanhChinh: 'Số đơn vị hành chính',
      dungLuong: 'Dung lượng đã dùng',
      dongBo: 'Đồng bộ',
      hanhDong: 'Hành động',
    },
    chuyenNguCanh: 'Chuyển vào xem tỉnh này',
    dangChuyen: 'Đang chuyển…',
    xacNhanChuyen:
      'Chuyển ngữ cảnh sang tỉnh này? Toàn bộ màn hình danh sách sẽ chỉ hiển thị dữ liệu của tỉnh đó.',
    daChuyen: 'Đã chuyển vào ngữ cảnh',
    dangXemTinh: 'ĐANG XEM MỘT TỈNH CỤ THỂ',
    thoatNguCanh: 'Về xem toàn hệ thống (đăng nhập lại)',
    rongMoTa: 'Chưa có tỉnh nào trong hệ thống.',
    /** Thêm tỉnh mới (hợp đồng A0 đa tỉnh mục 4). */
    themTinh: {
      nut: 'Thêm tỉnh mới',
      tieuDe: 'Thêm tỉnh mới',
      nhomTinh: 'Thông tin tỉnh',
      nhomQuanTri: 'Tài khoản quản trị tỉnh',
      maTinh: 'Mã tỉnh',
      maTinhMoTa: 'Dạng H và 2 chữ số, ví dụ H45.',
      tenTinh: 'Tên tỉnh',
      emailCongVu: 'E-mail công vụ',
      tenDangNhap: 'Tên đăng nhập',
      tenDangNhapMoTa: 'Duy nhất trên toàn hệ thống; quản trị tỉnh đăng nhập bằng đúng tên này.',
      hoTen: 'Họ tên',
      email: 'E-mail',
      huy: 'Huỷ',
      tiepTuc: 'Tiếp tục',
      dangTao: 'Đang tạo…',
      loiMaTinh: 'Mã tỉnh phải có dạng H và 2 chữ số, ví dụ H45.',
      loiTenTinh: 'Chưa nhập tên tỉnh.',
      loiTenDangNhap: 'Chưa nhập tên đăng nhập của quản trị tỉnh.',
      loiTenDangNhapKyTu: 'Tên đăng nhập không được chứa khoảng trắng.',
      loiHoTen: 'Chưa nhập họ tên của quản trị tỉnh.',
      loiEmail: 'E-mail không hợp lệ.',
      xacNhanTieuDe: 'Xác nhận tạo tỉnh',
      xacNhanHeQua:
        'Tạo tỉnh {tenTinh} ({maTinh}) cùng 1 tài khoản quản trị tỉnh "{tenDangNhap}". Mã tỉnh không đổi được sau khi tạo.',
      xacNhanNut: 'Tạo tỉnh',
      daTaoTieuDe: 'Đã tạo tỉnh {tenTinh} ({maTinh}) — tài khoản {tenDangNhap}',
      buocTiepTieuDe: 'Bước tiếp theo',
      buocTiep: [
        'Gửi tên đăng nhập và mật khẩu ban đầu cho quản trị tỉnh qua kênh an toàn.',
        'Quản trị tỉnh đăng nhập tại cùng địa chỉ CMS, đổi mật khẩu lần đầu.',
        'Nhập Danh mục hành chính (xã, phường) của tỉnh.',
        'Tạo tài khoản cấp xã cho các xã, phường.',
        'Khai báo thiết bị (cụm loa, bảng tin) của tỉnh.',
      ],
      loi: {
        DUPLICATE: 'Mã tỉnh hoặc tên đăng nhập đã được sử dụng.',
        INVALID_VALUE: 'Dữ liệu chưa hợp lệ.',
        FORBIDDEN: 'Bạn không có quyền tạo tỉnh mới.',
        macDinh: 'Không tạo được tỉnh.',
      },
      chiTietLoi: 'Chi tiết: {chiTiet}',
    },
  },

  /* --------------------------- MH-40/41 Hồ sơ cá nhân & bảo mật --------------------------- */
  hoSoCaNhan: {
    tieuDe: 'Hồ sơ cá nhân',
    thongTinTaiKhoan: 'Thông tin tài khoản',
    tenDangNhap: 'Tên đăng nhập',
    hoTen: 'Họ tên',
    tinh: 'Tỉnh',
    nhom: 'Nhóm quyền',
    baoMat: 'Bảo mật đăng nhập hai lớp (2FA)',
    thietLap2fa: 'Thiết lập xác thực hai lớp',
    quetMa: 'Quét mã bằng ứng dụng xác thực (Google Authenticator, Authy…) hoặc nhập thủ công:',
    nhapMaXacNhan: 'Nhập mã 6 số để xác nhận và bật',
    ma: 'Mã xác thực',
    kichHoat: 'Kích hoạt',
    tat2fa: 'Tắt xác thực hai lớp',
    maDuPhongTieuDe: 'Mã dự phòng — lưu lại, mỗi mã chỉ dùng được một lần:',
    daBat2fa: 'Đã bật xác thực hai lớp.',
    daTat2fa: 'Đã tắt xác thực hai lớp.',
    huy: 'Huỷ',
  },
  thietBiTinCayPhien: {
    tieuDe: 'Phiên đăng nhập',
    moTa: 'Danh sách phiên đăng nhập đang hoạt động trên các thiết bị. Thu hồi một phiên để đăng xuất thiết bị đó ngay lập tức.',
    cot: {
      thietBi: 'Thiết bị / trình duyệt',
      diaChiIp: 'Địa chỉ IP',
      taoLuc: 'Đăng nhập lúc',
      hoatDongGanNhat: 'Hoạt động gần nhất',
      hetHan: 'Hết hạn lúc',
    },
    phienHienTai: 'Phiên hiện tại',
    thuHoi: 'Thu hồi',
    xacNhanThuHoi: 'Thu hồi phiên đăng nhập này? Thiết bị tương ứng sẽ bị đăng xuất ngay.',
    daThuHoi: 'Đã thu hồi phiên đăng nhập.',
    rongMoTa: 'Không có phiên đăng nhập nào đang hoạt động.',
  },

  /* ------------------- Đợt 3 phần C3 — MH-24/25/26 Bảng tin điện tử ------------------ */
  bangDienTu: {
    /* MH-24 — danh sách và chi tiết bảng tin */
    danhSachTieuDe: 'Bảng tin điện tử',
    khaiBaoMoi: 'Khai báo bảng tin mới',
    cot: {
      tenThietBi: 'Tên bảng tin',
      diaBan: 'Địa bàn',
      nhaCungCap: 'Nhà cung cấp',
      huongManHinh: 'Hướng màn hình',
      doPhanGiai: 'Độ phân giải',
      trangThai: 'Trạng thái',
      capNhatLuc: 'Cập nhật lúc',
      hanhDong: 'Hành động',
    },
    moChiTiet: 'Xem chi tiết',
    rongMoTa: 'Địa bàn của bạn chưa khai báo bảng tin điện tử nào.',
    huongNgang: 'Màn ngang',
    huongDoc: 'Màn dọc',
    huongChuaKhaiBao: 'Chưa khai báo hướng màn hình',
    chiTiet: {
      ve: 'Bảng tin điện tử',
      tab: { chung: 'Thông tin chung', anhChup: 'Ảnh chụp màn hình gần nhất' },
      maThietBi: 'Mã thiết bị',
      nhaCungCap: 'Nhà cung cấp',
      phuongThucKetNoi: 'Phương thức kết nối',
      doPhanGiai: 'Độ phân giải (mô tả)',
      kichThuocPx: 'Kích thước theo điểm ảnh',
      huongManHinh: 'Hướng màn hình',
      dienTich: 'Diện tích màn hình (m²)',
      soVungPhat: 'Số vùng phát',
      trongNha: 'Lắp đặt trong nhà',
      capBaoVe: 'Cấp bảo vệ vỏ ngoài',
      boDieuKhien: 'Bộ điều khiển',
      anhChupLuc: 'Chụp lúc',
      anhChupChuaCo: 'Thiết bị chưa gửi ảnh chụp màn hình lần nào.',
      taiAnhChupMoi: 'Tải ảnh chụp mới',
      chuaCo: '—',
      sua: 'Sửa thuộc tính',
      luu: 'Lưu',
      huy: 'Hủy',
      daLuu: 'Đã lưu thuộc tính bảng tin.',
    },
    /* MH-25 — biên tập bản tin điện tử */
    bienTap: {
      danhSachTieuDe: 'Bản tin điện tử',
      taoMoi: 'Soạn bản tin mới',
      tieuDeMoi: 'Bản tin điện tử mới',
      guiDuyet: 'Gửi duyệt',
      luuNhap: 'Lưu nháp',
      dangLuu: 'Đang lưu…',
      daLuuLuc: 'Đã lưu nháp lúc {luc}',
      canhBaoRoiTrang: 'Bản tin còn thay đổi chưa lưu. Rời trang sẽ mất các thay đổi này.',
      nhanTieuDe: 'Tiêu đề',
      nhanLinhVuc: 'Lĩnh vực',
      nhanNoiDung: 'Nội dung tóm tắt',
      nhanVungPhat: 'Vùng phát thiết bị',
      toanManHinh: 'Toàn màn hình',
      vungSo: 'Vùng {so}',
      dieuKienGuiDuyet: 'Bản tin phải có ít nhất một khung nội dung mới gửi duyệt được.',
      khungNoiDung: 'Khung nội dung (hiển thị theo đúng thứ tự trong vòng lặp)',
      khungRong: 'Chưa có khung nội dung nào. Thêm ít nhất một khung để gửi duyệt.',
      themKhung: 'Thêm khung nội dung',
      xoaKhung: 'Xóa khung',
      diChuyenLen: 'Di chuyển lên',
      diChuyenXuong: 'Di chuyển xuống',
      loaiKhungNhan: {
        van_ban: 'Văn bản chạy',
        anh: 'Ảnh',
        video: 'Video',
        dong: 'Khung thông tin động',
      },
      noiDungKhung: 'Nội dung / đường dẫn',
      thoiLuongKhung: 'Thời lượng hiển thị (giây)',
      xemTruoc: 'Xem trước theo bảng tin đích',
      xemTruocMoTa:
        'Vùng xem trước dưới đây đúng tỷ lệ và hướng màn hình của bảng tin được chọn — nội dung thiết kế cho màn ngang không dùng lại được cho màn dọc.',
      chonBangTinDich: 'Chọn bảng tin để xem trước',
      chuaChonBangTin: 'Chưa chọn bảng tin nào để xem trước.',
      canhBaoDaDoPhanGiai:
        'Các bảng tin đã chọn có hướng màn hình hoặc độ phân giải KHÁC NHAU: nội dung thiết kế cho màn ngang sẽ không hiển thị đúng trên màn dọc (và ngược lại). Hãy tạo bản tin riêng cho từng nhóm độ phân giải, hoặc kiểm tra kỹ từng khung trước khi gửi duyệt.',
      khungRongDeXem: 'Thêm khung nội dung để xem trước.',
    },
    /* MH-26 — lịch phát vòng lặp */
    lichPhat: {
      tieuDe: 'Lịch phát bảng tin điện tử (vòng lặp)',
      taoMoi: 'Tạo lịch phát vòng lặp',
      nhanTenLich: 'Tên lịch phát',
      nhanPhamVi: 'Phạm vi địa bàn',
      nhanNgayBatDau: 'Ngày bắt đầu hiệu lực',
      nhanNgayKetThuc: 'Ngày kết thúc hiệu lực',
      nhanKhungGio: 'Khung giờ phát trong ngày',
      nhanNguongCanhBao: 'Ngưỡng cảnh báo một vòng (giây)',
      danhSachBanTinTieuDe: 'Bản tin trong vòng lặp (theo thứ tự phát)',
      themBanTin: 'Thêm bản tin vào vòng lặp',
      chonBanTin: 'Chọn bản tin đã duyệt',
      thoiLuongMoiLuot: 'Thời lượng mỗi lượt (giây)',
      xoaKhoiVongLap: 'Bỏ khỏi vòng lặp',
      vongLapRong: 'Vòng lặp chưa có bản tin nào. Thêm ít nhất một bản tin để lưu lịch phát.',
      tongThoiLuong: 'Tổng thời lượng một vòng',
      giay: 'giây',
      canhBaoVuotNguong:
        'Tổng thời lượng một vòng ({tong}s) VƯỢT ngưỡng cảnh báo ({nguong}s). Vòng lặp vẫn được lưu, nhưng hãy kiểm tra lại vì một vòng quá dài có thể khiến bản tin ở cuối danh sách hiếm khi được xem thấy.',
      xacNhanTrongNguong: 'Tổng thời lượng một vòng ({tong}s) trong ngưỡng cảnh báo ({nguong}s).',
      luu: 'Lưu lịch phát',
      huy: 'Hủy',
      daTao: 'Đã tạo lịch phát vòng lặp.',
      rongMoTa: 'Cần tên lịch phát, phạm vi địa bàn và ít nhất một bản tin trong vòng lặp.',
      xemLichDaTao: 'Xem lại lịch vừa tạo',
    },
  },
} as const;

export type BoNgonNgu = typeof vi;

/** Thay chỗ giữ trong chuỗi ngôn ngữ: `dienVao('Đã chọn {so}', { so: 5 })`. */
export function dienVao(mau: string, giaTri: Record<string, string | number>): string {
  return mau.replace(/\{(\w+)\}/g, (_, k: string) => String(giaTri[k] ?? `{${k}}`));
}
